import { Filters } from '../services/Filters.service';

export class PayloadListAbstract {
  constructor () {
    this.text = null;
    this.pageNumber = null;
    this.limit = null;
    this.filters = null;
  }

  // Removes empty objects and falsy values from instance
  getCleanPayload () {
    return Filters.removeEmptyObjects({
      ...this,
      filters: Filters.removeFalsyValues(this.filters)
    });
  }
}
